<template>

</template>

<script>

import {createNamespacedHelpers} from 'vuex';
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('users');

  export default {
    data: () => ({
    }),
    props: {
      source: String
    },
    methods: {

    },
    mounted() {
      // this.$validator.localize('en', this.dictionary);
    }
  }
</script>
